import axios from 'axios';
import {
  Account,
  Accounts,
  ApiResponse,
  Environments,
  TestPlanRequest,
  TestPlanResponse,
  VirtualRoomRequest,
  VirtualRoomResponse
} from '../types/api';

const API_BASE_URL = process.env.VITE_API_URL;

if (!API_BASE_URL) {
  throw new Error("VITE_API_URL is not defined in your environment variables.");
}

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to all requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Gemini API - 生成測試計劃
export const generateTestPlan = async (request: TestPlanRequest): Promise<ApiResponse<TestPlanResponse>> => {
  const response = await api.post('/api/test-plan/generate', request);
  return response.data;
};

// HiLink API - 創建虛擬教室
export const createVirtualRoom = async (request: VirtualRoomRequest): Promise<ApiResponse<VirtualRoomResponse>> => {
  const response = await api.post('/api/virtual-room/create', request);
  return response.data;
};

// 健康檢查
export const healthCheck = async (): Promise<ApiResponse<{ status: string }>> => {
  const response = await api.get('/health');
  return response.data;
};

// Fetch environments
export const getEnvironments = async (): Promise<string[] | undefined> => {
  const response = await api.get<ApiResponse<Environments>>('/api/config/environments');
  if (response.data.success) {
    return response.data.data?.environments;
  }
  throw new Error(response.data.error || 'Failed to fetch environments');
};

// Fetch accounts for a given environment
export const getAccounts = async (environment: string): Promise<Account[] | undefined> => {
  const response = await api.get<ApiResponse<Accounts>>(`/api/config/accounts?environment=${environment}`);
  if (response.data.success) {
    return response.data.data?.accounts;
  }
  throw new Error(response.data.error || 'Failed to fetch accounts');
};

// Generate Deep Link for a specific role
export const generateDeepLink = async (
  token: string,
  attendeeName: string,
  environment: string,
  account: string
): Promise<string> => {
  const response = await api.post('/api/deep-link/generate', {
    token,
    attendeeName,
    environment,
    account,
  });

  if (response.data.success && response.data.data?.joinToken) {
    return response.data.data.joinToken;
  }

  throw new Error(response.data.error || '無法生成 Deep Link');
};